import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import API, { getUploadUrl } from '../../services/api';
import useToast from './useToast';

const CATS  = ['Global Business Leaders','Business Leaders','Women In Business','Leadership','Medicine','Education','Technology','Press Release'];
const authH = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });
const isDemoMode = () => localStorage.getItem('adminMode') === 'demo';
const slugify    = s => s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
const EMPTY = { title:'', excerpt:'', content:'', category:'Leadership', tag:'', imageUrl:'', slug:'', author:'Editorial Team', readTime:'5 min read', featured:false, coverStory:false };

const DEMO_ARTICLES = [
  { _id:'a1', title:'Reinventing Success with Revolutionary Leadership',           category:'Global Business Leaders', slug:'reinventing-success',   imageUrl:'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'5 min read', featured:true,  coverStory:true,  views:8200  },
  { _id:'a2', title:'The Most Empowering Women to Watch in 2024',                  category:'Business Leaders',        slug:'empowering-women-2024', imageUrl:'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'4 min read', featured:false, coverStory:true,  views:7600  },
  { _id:'a3', title:'Pioneering a Sustainable Procurement Strategy',               category:'Global Business Leaders', slug:'sustainable-proc',      imageUrl:'https://images.unsplash.com/photo-1497366216548-37526070297c?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'6 min read', featured:false, coverStory:true,  views:5400  },
  { _id:'a4', title:'Most Inspiring Women Leaders Revamping the Future, 2024',     category:'Global Business Leaders', slug:'inspiring-women-2024',  imageUrl:'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'3 min read', featured:false, coverStory:false, views:9800  },
  { _id:'a5', title:'The Most Empowering Women Leader to Watch in 2026',           category:'Women In Business',       slug:'empowering-leader-2026',imageUrl:'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=140&h=100&fit=crop&q=80', author:'Sarah Chen',    readTime:'4 min read', featured:true,  coverStory:false, views:8900  },
  { _id:'a6', title:'8 Proven Strategies for Fostering Innovative Leadership',     category:'Leadership',              slug:'innovative-leadership', imageUrl:'https://images.unsplash.com/photo-1551836022-4af4c6098571?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'7 min read', featured:false, coverStory:false, views:7200  },
  { _id:'a7', title:'The Most Visionary Business Leader To Watch In 2026',         category:'Global Business Leaders', slug:'visionary-biz-2026',    imageUrl:'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=140&h=100&fit=crop&q=80', author:'Editorial Team', readTime:'5 min read', featured:false, coverStory:false, views:6700  },
  { _id:'a8', title:'The Most Successful Business Leaders to Watch in 2025',       category:'Business Leaders',        slug:'business-leaders-2025', imageUrl:'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=140&h=100&fit=crop&q=80', author:'Marcus Williams',readTime:'5 min read',featured:false,coverStory:true,  views:5100  },
];

let demoArtCounter = 200;

export default function AdminArticles() {
  const [articles, setArticles] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [catF,     setCatF]     = useState('');
  const [modal,    setModal]    = useState(false);
  const [editing,  setEditing]  = useState(null);
  const [form,     setForm]     = useState(EMPTY);
  const [saving,   setSaving]   = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [imgTab,   setImgTab]   = useState('url');
  const [uploads,  setUploads]  = useState([]);
  const [uploading,setUploading]= useState(false);
  const [uploadPct,setUploadPct]= useState(0);
  const [page,     setPage]     = useState(1);
  const PER = 8;
  const imgRef = useRef();
  const { addToast, ToastContainer } = useToast();

  const fetchArticles = async () => {
    setLoading(true);
    if (isDemoMode()) {
      setTimeout(() => { setArticles([...DEMO_ARTICLES]); setLoading(false); }, 400);
      return;
    }
    try {
      const r = await API.get('/articles', { headers: authH() });
      setArticles(r.data.data?.length ? r.data.data : [...DEMO_ARTICLES]);
    } catch { setArticles([...DEMO_ARTICLES]); }
    finally  { setLoading(false); }
  };

  const fetchUploads = async () => {
    if (isDemoMode()) return;
    try {
      const r = await API.get('/upload?type=image', { headers: authH() });
      setUploads(r.data.data || []);
    } catch {}
  };

  useEffect(() => { fetchArticles(); }, []);

  const openCreate = () => { setEditing(null); setForm(EMPTY); setImgTab('url'); setModal(true); fetchUploads(); };
  const openEdit   = a  => {
    setEditing(a);
    setForm({ title:a.title, excerpt:a.excerpt||'', content:a.content||'',
      category:a.category, tag:a.tag||'', imageUrl:a.imageUrl||'',
      slug:a.slug, author:a.author||'Editorial Team',
      readTime:a.readTime||'5 min read',
      featured:!!a.featured, coverStory:!!a.coverStory });
    setImgTab('url'); setModal(true); fetchUploads();
  };
  const closeModal = () => { setModal(false); setEditing(null); };
  const setF = (k,v) => setForm(f => { const n={...f,[k]:v}; if(k==='title'&&!editing) n.slug=slugify(v); return n; });

  const handleFileUpload = async file => {
    if (!file) return;
    if (isDemoMode()) {
      setF('imageUrl', URL.createObjectURL(file));
      addToast('Image selected (demo mode)', 'info'); return;
    }
    const fd = new FormData(); fd.append('file', file);
    setUploading(true); setUploadPct(0);
    try {
      const r = await API.post('/upload/image', fd, {
        headers: { ...authH(), 'Content-Type':'multipart/form-data' },
        onUploadProgress: e => setUploadPct(Math.round(e.loaded*100/e.total)),
      });
      setF('imageUrl', getUploadUrl(r.data.data.url));
      addToast('Image uploaded!', 'success'); fetchUploads();
    } catch { addToast('Upload failed', 'error'); }
    finally  { setUploading(false); setUploadPct(0); }
  };

  const handleSave = async e => {
    e.preventDefault();
    if (!form.title||!form.slug) return addToast('Title and slug required','error');
    if (isDemoMode()) {
      setSaving(true);
      await new Promise(r => setTimeout(r,500));
      if (editing) {
        setArticles(prev => prev.map(a => a._id===editing._id ? {...a,...form} : a));
        addToast('Article updated! (demo)', 'success');
      } else {
        setArticles(prev => [{ ...form, _id:`demo-a${++demoArtCounter}`, views:0 }, ...prev]);
        addToast('Article created! (demo)', 'success');
      }
      setSaving(false); closeModal(); return;
    }
    setSaving(true);
    try {
      if (editing) { await API.put(`/articles/${editing._id}`, form, { headers:authH() }); addToast('Updated!','success'); }
      else          { await API.post('/articles', form, { headers:authH() }); addToast('Created!','success'); }
      closeModal(); fetchArticles();
    } catch(err) { addToast(err.response?.data?.message||'Save failed','error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this article?')) return;
    setDeleting(id);
    if (isDemoMode()) {
      await new Promise(r => setTimeout(r,400));
      setArticles(prev => prev.filter(a => a._id !== id));
      addToast('Deleted (demo)', 'success'); setDeleting(null); return;
    }
    try {
      await API.delete(`/articles/${id}`, { headers:authH() });
      addToast('Deleted','success'); fetchArticles();
    } catch { addToast('Delete failed','error'); }
    finally { setDeleting(null); }
  };

  const filtered = articles.filter(a =>
    (!catF   || a.category===catF) &&
    (!search || a.title.toLowerCase().includes(search.toLowerCase()))
  );
  const pages = Math.ceil(filtered.length/PER);
  const paged = filtered.slice((page-1)*PER, page*PER);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Articles</h1>
          <p className="page-subtitle">{articles.length} total articles</p>
        </div>
        <div className="page-actions">
          <button className="btn btn-primary" onClick={openCreate}>+ New Article</button>
        </div>
      </div>

      <div className="table-card">
        <div className="table-header">
          <span className="table-title">All Articles</span>
          <div className="table-controls">
            <div className="search-box">
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="M21 21l-4.35-4.35"/></svg>
              <input placeholder="Search articles…" value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}/>
            </div>
            <select className="filter-select" value={catF}
              onChange={e => { setCatF(e.target.value); setPage(1); }}>
              <option value="">All Categories</option>
              {CATS.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <div style={{ overflowX:'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width:64 }}>Image</th>
                <th>Title</th>
                <th>Category</th>
                <th>Author</th>
                <th>Views</th>
                <th>Flags</th>
                <th style={{ width:110, textAlign:'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({length:4}).map((_,i) => (
                  <tr key={i}>{[64,300,120,100,60,80,110].map((w,j) => (
                    <td key={j}><div style={{ height:13, background:'var(--card2)', borderRadius:3, width:j===0?50:'75%', animation:'pulse 1.4s infinite' }}/></td>
                  ))}</tr>
                ))
              ) : paged.length === 0 ? (
                <tr><td colSpan={7}><div className="empty-state">
                  <div className="empty-title">No articles found</div>
                </div></td></tr>
              ) : paged.map(a => (
                <tr key={a._id}>
                  <td>
                    {a.imageUrl
                      ? <img src={a.imageUrl} alt="" style={{ width:50,height:50,objectFit:'cover',borderRadius:4,border:'1px solid var(--border-lt)',display:'block' }} onError={e=>e.target.style.display='none'}/>
                      : <div style={{ width:50,height:50,background:'var(--card2)',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.2rem' }}>📝</div>
                    }
                  </td>
                  <td>
                    <div style={{ fontWeight:500,color:'var(--white)',maxWidth:280,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{a.title}</div>
                    <div style={{ fontSize:'.72rem',color:'var(--white40)',marginTop:2 }}>/{a.slug} · {a.readTime}</div>
                  </td>
                  <td><span className="badge badge-gold" style={{ whiteSpace:'nowrap' }}>{a.category}</span></td>
                  <td style={{ fontSize:'.8rem',color:'var(--white70)' }}>{a.author}</td>
                  <td style={{ fontSize:'.82rem',color:'var(--white70)',fontVariantNumeric:'tabular-nums' }}>{(a.views||0).toLocaleString()}</td>
                  <td>
                    <div style={{ display:'flex',gap:5,flexWrap:'wrap' }}>
                      {a.featured   && <span className="badge badge-blue">Featured</span>}
                      {a.coverStory && <span className="badge badge-purple">Cover</span>}
                    </div>
                  </td>
                  <td>
                    <div className="row-actions">
                      <button className="act-edit"   onClick={() => openEdit(a)}>✏️</button>
                      <button className="act-delete" disabled={deleting===a._id}
                        onClick={() => handleDelete(a._id)}>{deleting===a._id?'⏳':'🗑️'}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {pages > 1 && (
          <div className="pagination">
            <span className="pagination-info">Page {page} of {pages} · {filtered.length} articles</span>
            <div className="pagination-btns">
              <button className="page-btn" disabled={page===1}     onClick={()=>setPage(p=>p-1)}>‹</button>
              {Array.from({length:pages},(_,i)=>i+1).slice(Math.max(0,page-3),page+2).map(p=>(
                <button key={p} className={`page-btn${p===page?' active':''}`} onClick={()=>setPage(p)}>{p}</button>
              ))}
              <button className="page-btn" disabled={page===pages} onClick={()=>setPage(p=>p+1)}>›</button>
            </div>
          </div>
        )}
      </div>

      {/* ── Modal ── */}
      {modal && (
        <div className="modal-root">
          <div className="modal-backdrop" onClick={closeModal}/>
          <div className="modal-panel">
            <div className="modal-head">
              <h2>{editing ? 'Edit Article' : 'New Article'}</h2>
              <button className="modal-close" onClick={closeModal}>✕</button>
            </div>
            <div className="modal-body">
              <form id="art-form" onSubmit={handleSave}>
                <div className="form-grid">
                  <div className="form-group full">
                    <label className="form-label">Title <span className="req">*</span></label>
                    <input className="form-input" value={form.title} required
                      onChange={e=>setF('title',e.target.value)} placeholder="Article headline…"/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Slug <span className="req">*</span></label>
                    <input className="form-input" value={form.slug} required
                      onChange={e=>setF('slug',slugify(e.target.value))}/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Category</label>
                    <select className="form-select" value={form.category} onChange={e=>setF('category',e.target.value)}>
                      {CATS.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Author</label>
                    <input className="form-input" value={form.author} onChange={e=>setF('author',e.target.value)}/>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Read Time</label>
                    <input className="form-input" value={form.readTime} onChange={e=>setF('readTime',e.target.value)} placeholder="5 min read"/>
                  </div>
                  <div className="form-group full">
                    <label className="form-label">Excerpt</label>
                    <textarea className="form-textarea" rows={2} value={form.excerpt}
                      onChange={e=>setF('excerpt',e.target.value)} placeholder="Short summary…"/>
                  </div>
                  <div className="form-group full">
                    <label className="form-label">Content</label>
                    <textarea className="form-textarea" rows={5} value={form.content}
                      onChange={e=>setF('content',e.target.value)} placeholder="Full article body…"
                      style={{ minHeight:120 }}/>
                  </div>
                  {/* Image */}
                  <div className="form-group full">
                    <label className="form-label">Cover Image</label>
                    <div className="tabs" style={{ marginBottom:12 }}>
                      {['url','upload','library'].map(t=>(
                        <button key={t} type="button" className={`tab-btn${imgTab===t?' active':''}`}
                          onClick={()=>{setImgTab(t);if(t==='library')fetchUploads();}}>
                          {t==='url'?'🔗 URL':t==='upload'?'⬆️ Upload':'🖼 Library'}
                        </button>
                      ))}
                    </div>
                    {imgTab==='url' && (
                      <input className="form-input" value={form.imageUrl}
                        onChange={e=>setF('imageUrl',e.target.value)} placeholder="https://…"/>
                    )}
                    {imgTab==='upload' && (
                      <div className="drop-zone" onClick={()=>imgRef.current?.click()}
                        onDragOver={e=>{e.preventDefault();e.currentTarget.classList.add('drag-over');}}
                        onDragLeave={e=>e.currentTarget.classList.remove('drag-over')}
                        onDrop={e=>{e.preventDefault();e.currentTarget.classList.remove('drag-over');handleFileUpload(e.dataTransfer.files[0]);}}>
                        <input ref={imgRef} type="file" accept="image/*" style={{display:'none'}}
                          onChange={e=>handleFileUpload(e.target.files[0])}/>
                        <div className="drop-icon"><svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#c9a84c" strokeWidth="1.8"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg></div>
                        <div className="drop-title">Drop or <span style={{color:'var(--gold)',textDecoration:'underline'}}>browse</span></div>
                        {uploading && <div className="upload-progress" style={{marginTop:10}}><div className="progress-label"><span>Uploading…</span><span>{uploadPct}%</span></div><div className="progress-bar-wrap"><div className="progress-bar" style={{width:`${uploadPct}%`}}/></div></div>}
                      </div>
                    )}
                    {imgTab==='library' && (
                      <div className="media-library" style={{maxHeight:200,overflowY:'auto'}}>
                        {uploads.length===0
                          ? <div className="empty-state" style={{padding:20}}><div className="empty-title">No images yet</div></div>
                          : uploads.map(u=>(
                              <div key={u._id} className={`media-item${form.imageUrl.includes(u.filename)?' selected':''}`}
                                onClick={()=>setF('imageUrl',u.url)}>
                                <img src={getUploadUrl(u.url)} alt=""/>
                                <div className="media-check">✓</div>
                              </div>
                          ))
                        }
                      </div>
                    )}
                    {form.imageUrl && (
                      <div style={{display:'flex',alignItems:'center',gap:10,marginTop:10}}>
                        <img src={getUploadUrl(form.imageUrl)} alt="preview" style={{width:56,height:40,objectFit:'cover',borderRadius:4,border:'1px solid var(--border-lt)'}} onError={e=>e.target.style.display='none'}/>
                        <button type="button" onClick={()=>setF('imageUrl','')} style={{background:'none',border:'none',color:'var(--red)',cursor:'pointer',fontSize:'.78rem'}}>✕ Remove</button>
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-check">
                      <input type="checkbox" checked={form.featured} onChange={e=>setF('featured',e.target.checked)}/>
                      <span className="form-check-label">⭐ Featured</span>
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="form-check">
                      <input type="checkbox" checked={form.coverStory} onChange={e=>setF('coverStory',e.target.checked)}/>
                      <span className="form-check-label">📰 Cover Story</span>
                    </label>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-foot">
              <button className="btn btn-secondary" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" form="art-form" type="submit" disabled={saving}>
                {saving ? 'Saving…' : editing ? '✓ Update' : '+ Create'}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{to{transform:rotate(360deg)}} @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
      <ToastContainer/>
    </div>
  );
}
